
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/agreement",
      function () {
        return require("private-next-pages/web/agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/agreement"])
      });
    }
  